import React from 'react';
import { LayoutDashboard, Users, Megaphone, Star, Globe, User, Search, ChevronDown, Filter, Copy, Link2 } from 'lucide-react';
export const Sidebar = ({
  active
}: {
  active: string;
}) => {
  const menu = [{
    name: 'Dashboard',
    icon: LayoutDashboard
  }, {
    name: 'Roster Database',
    icon: Users
  }, {
    name: 'Casting Calls',
    icon: Megaphone
  }, {
    name: 'Talent Agencies',
    icon: Star
  }, {
    name: 'The Creator Network',
    icon: Globe,
    badge: 'New'
  }];
  return <div className="w-48 border-r border-gray-100 bg-white flex flex-col shrink-0 hidden md:flex" data-id="element-1319">
      <div className="p-4" data-id="element-1320">
        <div className="text-xl font-extrabold text-zano-pink lowercase tracking-tight" data-id="element-1321">
          zano
        </div>
      </div>
      <div className="px-3 py-2 text-[10px] font-semibold text-gray-400 uppercase tracking-wider" data-id="element-1322">
        Main Menu
      </div>
      <div className="space-y-0.5 px-2" data-id="element-1323">
        {menu.map(m => <div key={m.name} className={`flex items-center gap-2 px-2 py-1.5 rounded-md text-xs font-medium cursor-pointer ${active === m.name ? 'bg-pink-50 text-zano-pink' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1324">
            <m.icon size={14} className={active === m.name ? 'text-zano-pink' : 'text-gray-400'} data-id="element-1325" />
            <span className="truncate" data-id="element-1326">{m.name}</span>
            {m.badge && <span className="ml-auto text-[8px] bg-pink-100 text-zano-pink px-1.5 py-0.5 rounded-sm" data-id="element-1327">
                {m.badge}
              </span>}
          </div>)}
      </div>
    </div>;
};
export const Topbar = ({
  title,
  subtitle
}: {
  title: string;
  subtitle?: string;
}) => <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-white" data-id="element-1328">
    <div data-id="element-1329">
      <h1 className="text-lg font-bold text-gray-900" data-id="element-1330">{title}</h1>
      {subtitle && <p className="text-xs text-gray-500" data-id="element-1331">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2" data-id="element-1332">
      <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-500" data-id="element-1333">
        <User size={12} data-id="element-1334" />
      </div>
      <span className="text-xs font-medium text-gray-700 hidden sm:inline" data-id="element-1335">
        Sapir Tori
      </span>
    </div>
  </div>;
export const MockupLayout = ({
  active,
  title,
  subtitle,
  children
}: any) => <div className="bg-gray-50 rounded-xl border border-gray-200 shadow-sm overflow-hidden flex h-[400px] text-left w-full" data-id="element-1336">
    <Sidebar active={active} data-id="element-1337" />
    <div className="flex-1 flex flex-col overflow-hidden min-w-0" data-id="element-1338">
      <Topbar title={title} subtitle={subtitle} data-id="element-1339" />
      <div className="flex-1 overflow-auto p-4" data-id="element-1340">{children}</div>
    </div>
  </div>;
export const TTIco = () => <span className="text-[10px] font-bold" data-id="element-1341">TT</span>;
export const IGIco = () => <span className="text-[10px] font-bold text-pink-500" data-id="element-1342">IG</span>;
export const YTIco = () => <span className="text-[10px] font-bold text-red-500" data-id="element-1343">YT</span>;
export const DirectoryMockup = () => {
  const agencies = [{
    name: 'United Talent Agency',
    short: 'UTA',
    inf: '895',
    tt: '2B',
    ig: '1B',
    yt: '0',
    email: 'CreatorsBrandPartnerships@unitedtalent.com'
  }, {
    name: 'Clicks Talent',
    short: 'CT',
    inf: '886',
    tt: '393M',
    ig: '285M',
    yt: '917M',
    email: 'ab@clickstalent.com',
    link: true
  }, {
    name: 'Viral Nation Inc',
    short: 'VN',
    inf: '442',
    tt: '759M',
    ig: '274M',
    yt: '286M',
    email: 'ena@viralnation.com',
    link: true
  }, {
    name: 'Viral Hub Marketing',
    short: 'VH',
    inf: '190',
    tt: '38M',
    ig: '14M',
    yt: '8M',
    email: 'daniel@viralhubmarketing.com',
    link: true
  }, {
    name: 'Connect Management',
    short: 'CM',
    inf: '150',
    tt: '232M',
    ig: '57M',
    yt: '20M',
    email: 'oliver@connectmgt.com',
    link: true
  }];
  return <MockupLayout active="Talent Agencies" title="Talent Agencies" data-id="element-1344">
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1345">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1346">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1347">
            <tr data-id="element-1348">
              <th className="px-3 py-2 font-medium" data-id="element-1349">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1350">Influencers ↑</th>
              <th className="px-3 py-2 font-medium" data-id="element-1351">
                <TTIco data-id="element-1352" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1353">
                <IGIco data-id="element-1354" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1355">
                <YTIco data-id="element-1356" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1357">Website</th>
              <th className="px-3 py-2 font-medium" data-id="element-1358">Email</th>
              <th className="px-3 py-2 font-medium" data-id="element-1359"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1360">
            {agencies.map((a, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1361">
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1362">
                  <div className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-[8px] font-bold shrink-0" data-id="element-1363">
                    {a.short}
                  </div>
                  <span className="font-medium text-gray-900" data-id="element-1364">{a.name}</span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1365">{a.inf}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1366">{a.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1367">{a.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1368">{a.yt}</td>
                <td className="px-3 py-2 text-gray-400" data-id="element-1369">
                  {a.link && <Link2 size={12} data-id="element-1370" />}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[120px]" data-id="element-1371">
                  {a.email}
                </td>
                <td className="px-3 py-2 text-right" data-id="element-1372">
                  <div className="flex items-center justify-end gap-2" data-id="element-1373">
                    <Copy size={12} className="text-gray-400" data-id="element-1374" />
                    <button className="border border-gray-200 text-gray-700 rounded px-2 py-1 text-[10px] font-medium bg-white" data-id="element-1375">
                      View Roster
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const CastingCallMockup = () => {
  const calls = [{
    name: 'Temu US campaign short form',
    budget: '$10,000 - $120,000',
    cat: '-',
    type: 'Paid Promo',
    plats: ['TT', 'IG'],
    posted: 'Braco US',
    date: 'Jun 26'
  }, {
    name: 'Kopouch World Cup Activation',
    budget: '$400 - $600',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'Jun 4'
  }, {
    name: 'Leesa Summer',
    budget: '$42 - $6,000',
    cat: 'Beauty, Book Reviews...',
    type: 'Paid Promo',
    plats: ['YT'],
    posted: 'The Outloud Group',
    date: 'May 22'
  }, {
    name: 'DJI',
    budget: '-',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'May 14'
  }];
  return <MockupLayout active="Casting Calls" title="Casting Calls" subtitle="24 Casting Calls" data-id="element-1376">
      <div className="flex items-center justify-between mb-3" data-id="element-1377">
        <div className="flex items-center gap-3" data-id="element-1378">
          <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700" data-id="element-1379">
            <Filter size={12} data-id="element-1380" /> All filters
          </button>
          <button className="text-xs text-gray-500 underline" data-id="element-1381">Clear all</button>
        </div>
        <button className="bg-pink-100 text-pink-600 px-3 py-1.5 rounded text-xs font-medium" data-id="element-1382">
          + New Casting Call
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1383">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1384">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1385">
            <tr data-id="element-1386">
              <th className="px-3 py-2 font-medium" data-id="element-1387">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1388">Budget</th>
              <th className="px-3 py-2 font-medium" data-id="element-1389">Category</th>
              <th className="px-3 py-2 font-medium" data-id="element-1390">Type of Collaboration</th>
              <th className="px-3 py-2 font-medium" data-id="element-1391">Platforms</th>
              <th className="px-3 py-2 font-medium" data-id="element-1392">Posted By</th>
              <th className="px-3 py-2 font-medium" data-id="element-1393">Date Posted</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1394">
            {calls.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1395">
                <td className="px-3 py-2 font-medium text-gray-900 truncate max-w-[150px]" data-id="element-1396">
                  {c.name}
                </td>
                <td className="px-3 py-2 text-green-600 font-medium" data-id="element-1397">
                  {c.budget}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[100px]" data-id="element-1398">
                  {c.cat}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1399">{c.type}</td>
                <td className="px-3 py-2 flex gap-1" data-id="element-1400">
                  {c.plats.includes('TT') && <TTIco data-id="element-1401" />}
                  {c.plats.includes('IG') && <IGIco data-id="element-1402" />}
                  {c.plats.includes('YT') && <YTIco data-id="element-1403" />}
                </td>
                <td className="px-3 py-2 text-gray-700 flex items-center gap-1" data-id="element-1404">
                  <div className="w-4 h-4 bg-gray-200 rounded-full shrink-0" data-id="element-1405"></div>
                  <span className="truncate max-w-[100px]" data-id="element-1406">{c.posted}</span>
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1407">{c.date}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const SubmissionsMockup = CastingCallMockup;
export const RosterDatabaseMockup = () => {
  const creators = [{
    name: 'Dr. Aamir Hussain',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '-',
    ig: '39.3K',
    yt: '2.9K',
    agency: 'KAW Management Group',
    excl: 'Non-Exclusive',
    email: 'connect@kawmanagementgroup.com'
  }, {
    name: 'Ganyah Goldstein',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '82.9K',
    ig: '38.1K',
    yt: '-',
    agency: 'Viral Hub Marketing',
    excl: 'Non-Exclusive',
    email: 'daniel@viralhubmarketing.com'
  }, {
    name: 'Julius Doyle',
    cat: 'Academia',
    country: 'United States',
    tt: '-',
    ig: '449.8K',
    yt: '-',
    agency: 'Clicks Talent',
    excl: 'Non-Exclusive',
    email: 'amaany@clickstalentagency.com'
  }, {
    name: 'Stephanie & Loreal',
    cat: 'Academia',
    country: 'United States',
    tt: '169.8K',
    ig: '456.8K',
    yt: '-',
    agency: 'Boost Society',
    excl: 'Exclusive',
    email: 'josh@boost-society.com'
  }];
  return <MockupLayout active="Roster Database" title="Roster Database" data-id="element-1408">
      <div className="flex items-center gap-2 mb-3 overflow-x-auto pb-1" data-id="element-1409">
        <div className="relative flex-1 min-w-[120px]" data-id="element-1410">
          <Search size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1411" />
          <input type="text" placeholder="Search" className="w-full pl-6 pr-2 py-1 border border-gray-200 rounded text-xs outline-none" data-id="element-1412" />
        </div>
        {['Platforms', 'Categories', 'Countries'].map(f => <button key={f} className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs text-gray-700 whitespace-nowrap" data-id="element-1413">
            {f} <ChevronDown size={10} data-id="element-1414" />
          </button>)}
        <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700 whitespace-nowrap" data-id="element-1415">
          <Filter size={12} data-id="element-1416" /> All filters
        </button>
        <button className="text-xs text-gray-500 underline whitespace-nowrap" data-id="element-1417">
          Clear all
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1418">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1419">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1420">
            <tr data-id="element-1421">
              <th className="px-3 py-2 font-medium" data-id="element-1422">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1423">Category ↓</th>
              <th className="px-3 py-2 font-medium" data-id="element-1424">Country</th>
              <th className="px-3 py-2 font-medium" data-id="element-1425">
                <TTIco data-id="element-1426" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1427">
                <IGIco data-id="element-1428" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1429">
                <YTIco data-id="element-1430" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1431">Agency Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1432">Exclusivity</th>
              <th className="px-3 py-2 font-medium" data-id="element-1433">Contact Email</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1434">
            {creators.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1435">
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1436">
                  <div className="w-5 h-5 bg-gray-200 rounded-full shrink-0" data-id="element-1437"></div>
                  <span className="font-medium text-gray-900 truncate max-w-[100px]" data-id="element-1438">
                    {c.name}
                  </span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1439">{c.cat}</td>
                <td className="px-3 py-2 text-gray-600 truncate max-w-[80px]" data-id="element-1440">
                  {c.country}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1441">{c.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1442">{c.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1443">{c.yt}</td>
                <td className="px-3 py-2 text-gray-700 truncate max-w-[100px]" data-id="element-1444">
                  {c.agency}
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1445">{c.excl}</td>
                <td className="px-3 py-2 text-gray-500 flex items-center justify-between gap-2" data-id="element-1446">
                  <span className="truncate max-w-[120px]" data-id="element-1447">{c.email}</span>
                  <Copy size={10} className="text-gray-400 shrink-0" data-id="element-1448" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const InsightsMockup = () => {
  return <MockupLayout active="Dashboard" title="Dashboard" data-id="element-1449">
      <div className="space-y-4" data-id="element-1450">
        <div data-id="element-1451">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1452">
            Talent Agencies
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1453">
            {[{
            title: 'TikTok Top Agencies',
            icon: <TTIco data-id="element-1454" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,886,760,587'
            }, {
              n: 'Viral Nation Inc',
              v: '758,591,677'
            }]
          }, {
            title: 'Instagram Top Agencies',
            icon: <IGIco data-id="element-1455" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,169,648,463'
            }, {
              n: 'Clicks Talent',
              v: '284,615,765'
            }]
          }, {
            title: 'YouTube Top Agencies',
            icon: <YTIco data-id="element-1456" />,
            data: [{
              n: 'Clicks Talent',
              v: '916,534,313'
            }, {
              n: 'Viral Nation Inc',
              v: '286,009,190'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1457">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1458">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1459">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1460">
                      <div className="flex items-center gap-1" data-id="element-1461">
                        <div className="w-3 h-3 bg-gray-900 rounded-full shrink-0" data-id="element-1462"></div>
                        <span className="text-gray-700 truncate max-w-[80px]" data-id="element-1463">
                          {d.n}
                        </span>
                      </div>
                      <span className="text-gray-500 font-medium" data-id="element-1464">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-1465">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1466">
            Pricing
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1467">
            {[{
            title: 'TikTok Pricing',
            icon: <TTIco data-id="element-1468" />,
            data: [{
              n: 'Video Post',
              v: '$7,746'
            }, {
              n: 'Link in Bio',
              v: '$5,378'
            }]
          }, {
            title: 'Instagram Pricing',
            icon: <IGIco data-id="element-1469" />,
            data: [{
              n: 'Photo',
              v: '$7,102'
            }, {
              n: 'Reels',
              v: '$8,722'
            }]
          }, {
            title: 'YouTube Pricing',
            icon: <YTIco data-id="element-1470" />,
            data: [{
              n: 'Integration',
              v: '$6,196'
            }, {
              n: 'Dedication',
              v: '$8,995'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1471">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1472">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1473">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1474">
                      <span className="text-gray-600" data-id="element-1475">{d.n}</span>
                      <span className="text-green-600 font-medium" data-id="element-1476">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </MockupLayout>;
};
export const MediaKitLinkMockup = () => <MockupLayout active="Talent Agencies" title="Media Kits" data-id="element-1477">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1478">
      <div className="border-b border-gray-100 p-4 flex items-center gap-2 bg-gray-50/50" data-id="element-1479">
        <Link2 size={16} className="text-gray-500" data-id="element-1480" />
        <span className="font-semibold text-sm text-gray-800 flex-1" data-id="element-1481">
          zano.co/agency/uta
        </span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1482">Copy link</span>
      </div>
      <div className="px-4 pt-3 flex items-center gap-2" data-id="element-1483">
        <div className="flex-1 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1 text-xs text-gray-400 flex items-center gap-1" data-id="element-1484">
          <Search size={11} data-id="element-1485" /> Filter by followers, niche, location…
        </div>
      </div>
      <div className="p-4 grid grid-cols-2 gap-3" data-id="element-1486">
        {[1, 2].map(c => <div key={c} className="border border-gray-100 rounded-lg p-3" data-id="element-1487">
            <div className="w-10 h-10 bg-gray-200 rounded-full mb-2" data-id="element-1488"></div>
            <div className="flex items-center gap-1.5" data-id="element-1489">
              <p className="text-sm font-semibold text-gray-900" data-id="element-1490">
                Creator Name
              </p>
            </div>
            <p className="text-xs text-gray-500" data-id="element-1491">1.2M • 4.8% ENG</p>
          </div>)}
      </div>
    </div>
  </MockupLayout>;
export const MediaKitMockup = () => <MockupLayout active="Talent Agencies" title="Creator Profile" data-id="element-1492">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1493">
      <div className="bg-gray-50 border-b border-gray-200 p-4 flex items-center gap-3" data-id="element-1494">
        <div className="w-12 h-12 bg-gray-200 rounded-full" data-id="element-1495"></div>
        <div data-id="element-1496">
          <h4 className="font-bold text-gray-900" data-id="element-1497">Elena Rodriguez</h4>
          <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-1498">
            <Globe size={12} data-id="element-1499" /> LA • UTA
          </p>
        </div>
      </div>
      <div className="p-4 grid grid-cols-3 gap-3" data-id="element-1500">
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1501">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1502">Followers</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1503">1.2M</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1504">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1505">Avg views</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1506">340K</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1507">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1508">Eng.</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1509">4.8%</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const RosterMockup = () => <MockupLayout active="Talent Agencies" title="Your Roster" data-id="element-1510">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1511">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-1512">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1513">Your Roster</span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1514">
          + Add creator
        </span>
      </div>
      <div className="p-4 grid grid-cols-2 gap-4" data-id="element-1515">
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1516">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1517">Active roster</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1518">42</p>
        </div>
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1519">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1520">Casting inbound</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1521">18</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const PartnerRosterMockup = () => <MockupLayout active="Talent Agencies" title="Partner Agencies" data-id="element-1522">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1523">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex items-center gap-2" data-id="element-1524">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1525">
          My partner agencies
        </span>
      </div>
      <div className="px-4 pt-3 flex gap-1.5" data-id="element-1526">
        {['UTA', 'Viral Nation', 'Fixated'].map(a => <span key={a} className="text-[10px] text-zano-pink bg-zano-blush rounded-full px-2 py-0.5 font-medium" data-id="element-1527">
            {a}
          </span>)}
      </div>
      <div className="p-4 space-y-3" data-id="element-1528">
        {[1, 2].map(c => <div key={c} className="flex items-center justify-between p-3 border border-gray-100 rounded-lg" data-id="element-1529">
            <div className="flex items-center gap-3" data-id="element-1530">
              <div className="w-9 h-9 bg-gray-200 rounded-full" data-id="element-1531"></div>
              <div data-id="element-1532">
                <p className="text-sm font-semibold text-gray-900" data-id="element-1533">
                  Creator {c}
                </p>
                <p className="text-xs text-gray-500" data-id="element-1534">Agency • live roster</p>
              </div>
            </div>
            <span className="text-xs bg-green-50 text-green-700 border border-green-200 px-2 py-0.5 rounded-full" data-id="element-1535">
              Updated
            </span>
          </div>)}
      </div>
    </div>
  </MockupLayout>;